module.exports = __webpack_public_path__ + "img/powered1.c3b2f1df.png";